import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=1665e280&lang=pug&"
import script from "./PhotoGallery.vue?vue&type=script&lang=js&"
export * from "./PhotoGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports